import React, { useRef, useState, useContext } from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ReactComponent as SliderRightArrow } from '../../../assets/icons/profile/facilityNavigate.svg';
import { ReactComponent as SliderLeftArrow } from '../../../assets/icons/profile/scroll-left-arrow.svg';
import { brandImage, currentBranding } from '../../../config/branding';
import ThemeContext from '../../../contexts/theme-context/ThemeContext';

/**
 * Banner component container auto change slider
 */
function BannerWithSlider() {
  const { theme } = useContext(ThemeContext);
  const sliderReference = useRef<Slider>(null);
  const [slideIndex, setSlideIndex] = useState<number>(0);

  const bannerDetails = [
    {
      title: 'Seamless Charging Control',
      description:
        'Experience effortless charging control, anywhere, anytime. Monitor, schedule, and adjust your charging sessions with ease. Enjoy convenient, flexible, and worry-free charging.',
    },
    {
      title: 'Real-time Monitor Dashboard ',
      description:
        'Equipment status, power consumed and income trend, etc. One dashboard, covers it all',
    },
    {
      title: 'Flexible Data Visualization ',
      description:
        'Extract income data, power consumed, fault history, from any station, any equipment, in any timeslot and generate intuitive chart for your report',
    },
    {
      title: 'Remote Maintenance',
      description:
        'Error statistics, fault report and handling, remote diagnostics & update, etc. Maintenance has never been easier!',
    },
  ];

  const settings = {
    dots: false,
    arrow: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    /**
     * Change the slideIndex state when slide is automatically changing
     * @param current
     * @param next
     */
    beforeChange: (current: number, next: number) => setSlideIndex(next),
    /**
     * Change the slideIndex state when slide is automatically changing
     * @param current
     * @returns
     */
    afterChange: (current: number) => setSlideIndex(current), // Sync the state after a slide change
  };

  /**
   * Change the slideIndex to previous when previous arrow is clicked
   */
  const handlePrevious = () => {
    if (sliderReference.current) {
      sliderReference.current.slickPrev();
    }
  };

  /**
   * Change the slideIndex to next when next arrow is clicked
   */
  const handleNext = () => {
    if (sliderReference.current) {
      sliderReference.current.slickNext();
    }
  };

  /**
   * Change the slider index when dot clicked based on index
   */
  const handleDotClick = (index: number) => {
    setSlideIndex(index); // Update local state
    if (sliderReference.current) {
      sliderReference.current.slickGoTo(index); // Programmatically go to the clicked slide
    }
  };

  return (
    <div className="sign-up-banner-wrap">
      <div className="banner-top">
        <div className="banner-image-container">
          <img src={brandImage.loginBanner} alt="" className="banner-image" />
        </div>
        <div className="banner-logo-container">
          <img
            src={theme === 'dark' ? brandImage.logoDarkTheme : brandImage.logo}
            alt=""
            className="banner-logo"
          />
          <div className={`blur-bg ${currentBranding}`} />
        </div>
      </div>
      <div className="banner-bottom">
        <div className="banner-slider-wrap">
          <div className="banner-slider-arrow-container">
            <div role="presentation" onClick={handlePrevious} className="slider-left-arrow">
              <SliderLeftArrow />
            </div>
            <div role="presentation" onClick={handleNext} className="slider-right-arrow">
              <SliderRightArrow />
            </div>
          </div>
          <div className="banner-slider-container">
            <Slider
              ref={sliderReference}
              dots={settings.dots}
              arrows={settings.arrow}
              infinite={settings.infinite}
              speed={settings.speed}
              slidesToShow={settings.slidesToShow}
              slidesToScroll={settings.slidesToScroll}
              autoplay={settings.autoplay}
              autoplaySpeed={settings.autoplaySpeed}
              beforeChange={settings.beforeChange}
              afterChange={settings.afterChange}>
              {bannerDetails?.map((bannerDetail) => (
                <div className="banner-slider">
                  <h2>{bannerDetail?.title}</h2>
                  <p>{bannerDetail?.description}</p>
                </div>
              ))}
            </Slider>
          </div>
          <div className="banner-slider-dots-container">
            {Array.from({ length: bannerDetails.length }, (_, index) => (
              <div
                className={`banner-slider-dot ${slideIndex === index ? 'active' : ''}`}
                role="presentation"
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="curved-border" />
    </div>
  );
}

export default BannerWithSlider;
